import { Component, Input } from '@angular/core';
import { Supplier } from '../product.types';
import { Country, Language } from '../../core/core.types';

@Component({
  selector: 'b4a-product-supplier-form',
  templateUrl: './supplier-form.component.html',
  styleUrls: ['./supplier-form.component.css']
})
export class SupplierFormComponent {
  @Input()
  supplier: Supplier;

  @Input()
  countries: Country[];

  @Input()
  languages: Language[];

  @Input()
  onSubmit;
}



// WEBPACK FOOTER //
// ./src/app/product/supplier-form/supplier-form.component.ts